module.exports = __webpack_public_path__ + "img/flower-answer-fluid.e47cfe8f.svg";